
<global-layout>
  <contextmenu :itemList="menuItemList" :visible.sync="menuVisible" @select="onMenuSelect"/>
  <a-tabs
    class="page-tabs"
    @contextmenu.native="e => onContextmenu(e)"
    v-if="multipage"
    :active-key="activePage"
    style="margin-top: -8px; margin-bottom: 8px"
    :hide-add="true"
    type="editable-card"
    @change="changePage"
    @edit="editPage">
    <a-tab-pane :id="page.fullPath" :key="page.fullPath" v-for="page in pageList" :closable="!isPinned(page)" forceRender>
      <span slot="tab" :pagekey="page.fullPath">{{page.name}}</span>
    </a-tab-pane>
  </a-tabs>
    <keep-alive v-if="multipage">
      <router-view/>
    </keep-alive>
    <router-view v-else/>
</global-layout>
